// Single source of truth for the GA4 `brand` parameter (values are case-sensitive in GA4)
export const GA4_UNKNOWN_BRAND = 'Unknown';

export const GA4_BRAND_BY_DOMAIN: Readonly<Record<string, string>> = {
  'financeify.co': 'Financeify',
  'financeify.com': 'Financeify',
  'pfiverify.com': 'PFI Verify',
  'verifyfinancialprofile.com': 'Verify Financial Profile',
  'financialinsightai.com': 'Financial Insights',
  'getpfiverify.com': 'Get PFI Verify',
  'getfinanceify.com': 'Get Financeify',
  'pfisimplify.com': 'PFI Simplify',
};

const PORTAL_HOST_PREFIX = /^app\.(?:stage\.)?/;

/** Strips the portal's app. / app.stage. prefix so one map serves both environments. */
export function getPortalBaseDomain(hostname: string): string {
  return (hostname ?? '').trim().toLowerCase().replace(PORTAL_HOST_PREFIX, '');
}

export function resolveGa4Brand(hostname: string): string {
  return GA4_BRAND_BY_DOMAIN[getPortalBaseDomain(hostname)] ?? GA4_UNKNOWN_BRAND;
}
